<script>
    import {facet_categories, categories, edit_dossier_categories} from '$lib/store.js';

    export let edit_dossier_context = false;
    export let show_counts = false;
    // Used to create unique 'id' attribute values
    export let filter_location = '';

    let _categories;
    if (edit_dossier_context) {
        _categories = edit_dossier_categories;
    } else {
        _categories = categories;
    }
</script>

<ul class="mb-0">
    <li>
        <label>
            <input type=checkbox id={'Media|Persberichten' + filter_location} bind:checked={$_categories['Media|Persberichten']}>
            Rijksoverheid.nl, Europese Commissie en Europees Parlement {#if show_counts}({#if typeof $facet_categories['Media'] != 'undefined'}{Intl.NumberFormat('nl-NL').format($facet_categories['Media']['Persberichten'].doc_count)}{:else}0{/if}){/if}
        </label>
    </li>
</ul>
